import React from 'react'
import { useContent } from '../../contexts/ContentContext'
import SectionWrapper from '../ui/SectionWrapper'
import SectionLabel from '../ui/SectionLabel'

export default function WhatIsSection() {
  const { whatIs } = useContent()

  return (
    <SectionWrapper data-section="WhatIsSection" id="was-ist" data-testid="whatis-section">
      {/* Hidden: ensures text-color-accent CSS is generated by Tailwind JIT */}
      <span className="hidden text-color-accent" aria-hidden="true"></span>
      <div className="grid md:grid-cols-2 grid-gap-xl items-start">
        {/* Left — sticky headline */}
        <div className="md:sticky md:top-32 md:align-self-start md:max-h-[25vh] md:overflow-hidden">
          <SectionLabel text={whatIs.label} />
          <h2 className="typography-hero-mobile md:typography-hero leading-tight">
            {whatIs.headline}
          </h2>
        </div>

        {/* Right — body + skeptic toggle */}
        <div>
          {whatIs.body.map((para, i) => (
            <p key={i} className={`typography-body ${i > 0 ? 'margin-top-sm' : ''}`}>
              {para}
            </p>
          ))}
        </div>
      </div>
    </SectionWrapper>
  )
}
